import { NavItem, NavItemType } from "@bagel-web/components";
import { WhoAmI } from "types/app";
import { useEffect, useState } from "react";

export const useNavConfig = ({
  whoAmI,
}: {
  whoAmI: WhoAmI | null;
}): NavItem[] => {
  const [showUsers, setShowUsers] = useState(false);

  useEffect(() => {
    const initUsersVisibility = async () => {
      if (whoAmI) {
        const hasManageUsersPermission =
          whoAmI?.permissions?.includes("widgets:users-table:manage") ?? false;
        setShowUsers(hasManageUsersPermission);
      }
    };
    initUsersVisibility();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whoAmI?.user.id, whoAmI?.organization.id]);

  const playgroundNavItems: Array<NavItem> = [
    {
      type: NavItemType.LINK,
      href: "/playground",
      iconClassName: "bi-play-fill",
      label: "Playground",
    },
  ];

  const usersNavItems: Array<NavItem> = showUsers
    ? [
        {
          type: NavItemType.LINK,
          href: "/users",
          iconClassName: "bi-people-fill",
          label: "Users",
        },
      ]
    : [];

  return [
    {
      type: NavItemType.SECTION_TITLE,
      label: whoAmI?.project?.name || "Project",
    },
    {
      type: NavItemType.LINK,
      href: "/sessions",
      isRootPath: true,
      iconClassName: "bi-clock-history",
      label: "Sessions",
    },
    {
      type: NavItemType.LINK,
      href: "/api-requests",
      iconClassName: "bi-arrow-left-right",
      label: "API Requests",
    },
    ...playgroundNavItems,
    {
      type: NavItemType.SECTION_TITLE,
      label: "Organization",
    },
    {
      type: NavItemType.LINK,
      href: "/projects",
      iconClassName: "bi-folder-fill",
      label: "Projects",
    },
    ...usersNavItems,
    {
      type: NavItemType.LINK,
      href: "/api-keys",
      iconClassName: "bi-braces",
      label: "API Keys",
    },
    {
      type: NavItemType.LINK,
      href: "/services",
      iconClassName: "bi-cpu-fill",
      label: "Services",
    },
    {
      type: NavItemType.SECTION_TITLE,
      label: "Documentation",
    },
    {
      type: NavItemType.LINK,
      href: "/documentation/api-reference",
      iconClassName: "bi-journal-text",
      label: (
        <span>
          API Reference{" "}
          <i style={{ fontSize: "0.8em" }} className="bi-box-arrow-up-right" />
        </span>
      ),
    },
  ];
};

export const getIsActive = (pathname: string) => (navItem: NavItem) => {
  return Boolean(
    navItem.type === NavItemType.LINK &&
    (pathname?.startsWith(navItem.href) ||
      (navItem.isRootPath && pathname === "/"))
  );
};
